export const ReportsTranslationsDictionary =
{
    // PIN Modal translations (reusing existing strings from old Backbone view)
    SetInspectionPIN: "Set Inspection PIN",
    ConfirmPIN: "Confirm PIN",
    WouldYouLikeToEnterPIN: "Would you like to enter a 4-digit PIN? If you enter a PIN, you must enter the same PIN to exit Roadside Check mode.",
    PleaseEnterPINAgain: "Please enter your 4-digit PIN again to confirm.",
    EnterFourDigitPINPlaceholder: "Enter 4-digit PIN",
    PINMustBeFourDigits: "The PIN must be a 4-digit number. Please try again.",
    PINsDoNotMatch: "The PIN does not match the first one you entered. Please try again.",
    NoPIN: "No PIN",
    SetPIN: "Set PIN",
    Cancel: "Cancel",
    ExitInspectionMode: "Exit Inspection Mode",
    ExitRoadsideCheckPIN: "You are exiting Roadside Check mode. Please enter your PIN to continue. If you have forgotten your PIN, start driving or log out to exit Roadside Check mode.",
    EnterPINToExitPlaceholder: "Enter PIN to exit",
    IncorrectPIN: "The PIN is incorrect. Please try again.",
    Continue: "Continue",
    LogOut: "Log out",

    // Main page translations
    RoadsideCheck: "Roadside Check",
    ErrorStoreNotAvailable: "Error: Store not available",
    ErrorAppNotAvailable: "Error: App not available",
    ELDReport: "ELD Report",

    // Report page translations
    ComplianceReport: "Compliance Report",
    ReportsTodo: "Reports -- TODO",

    // ELD Transfer translations
    Transfer: "Transfer",
    GatheringData: "Gathering data...",
    CheckConnectionDebug: "Check connection (debug)",
    Ping: "Ping",
    EmailAddress: "Email address:",
    EmailAddressPlaceholder: "Email address",
    EmailRequired: "You must enter an email address.",
    CommentsOptional: "Comments (optional):",
    OfficerCodeCommentsOptional: "Officer code/comments (optional):",
    CommentsPlaceholder: "Comments",
    CanadaELDEmailInfo: "The logs will be emailed to the email address you entered. The contents of the email will meet requirements for {0}.",
    USAELDTransferInfo: "Logs will be validated and transferred to FMCSA for {0} review only.",
    TransferCountry: "Transfer ({0})",
    EmailTransferCountry: "Email transfer ({0})",
    WebServicesTransfer: "Web services transfer",
    NotInCountry: "I'm not in {0}",

    // Transfer response translations
    Delivered: "Delivered",
    LogsSuccessfullySent: "Your logs have been successfully sent to the Officer for review.",
    ClickToSeeWarning: " Click the + symbol below to see the [Warning] message from the FMCSA.",
    Failed: "Failed",
    LogsNotSent: "The driver logs you requested were not sent because of the errors below. ",
    CorrectIssuesBeforeSending: "Correct these issues before sending a transfer. If transfer is unavailable or fails, " +
        "the driver can display the ELD records by clicking the Compliance print button.",
    TimeoutCommunicating: "Timeout communicating with FMCSA web service",
    TapHereToReview: "Tap here to review.",

    // Jurisdiction warning translations
    SwitchToCanadianELD: "Switch to Canadian ELD",
    SwitchToUSAELD: "Switch to USA ELD",
    CurrentlyDrivingInCanadian: "You are currently driving in a Canadian jurisdiction.",
    CurrentlyDrivingInUSA: "You are currently driving in a USA jurisdiction.",
    Graph: "Graph",
    Logs: "Logs",
    Malfunctions: "Malfunctions",
    UnassignedLogs: "Unassigned Logs",
    VehicleOdometer: "Vehicle Odometer",
    H: "h",
    IntLocation: "Int Location",
    No: "No",
    Yes: "Yes",
    NoVehicle: "No vehicle",
    Hours: "hours",
    Days: "{0} days",
    Cycle1: "Cycle 1",
    Cycle2: "Cycle 2",
    OffDutyDeferral: "Off-duty deferral",
    DayOne: "Day one",
    DayTwo: "Day two",
    CertificationOfRODS: "Certification of RODS",
    RecertificationOfRODS: "Re-certification of RODS",
    OperatingZone1CanadaSouth: "Operating Zone 1 (South of latitude 60°N in Canada)",
    OperatingZone2CanadaNorth: "Operating Zone 2 (North of latitude 60°N in Canada)",
    OperatingZone3US: "Operating Zone 3 (United States)",
    DiagnosticClear: "Diagnostic (Clear)",
    DiagnosticDetected: "Diagnostic (Detected)",
    MalfunctionClear: "Malfunction (Clear)",
    MalfunctionDetected: "Malfunction (Detected)",
    Timezone: "Timezone",
    UTC: "UTC",
    Code: "Code",
    DateOfCertifiedRODS: "Date of certified RODS",
    Time: "Time",
    Type: "Type",
    Location: "Location",
    Origin: "Origin",
    Odometer: "Odometer",
    EngineHours: "Engine hours",
    Annotations: "Annotations",
    SequenceNumber: "Sequence Number",
    NoLogsToDisplay: "No logs to display",
    RotateText: "Rotate your device or swipe the table below for more details",
    NoCarrierNumber: "No carrier number",
    ChangesInDriverDutyStatus: "Changes in Driver's Duty Status",
    LoginLogoutMalfunctions: "Login/Logout, Certification of RODS, Data Diagnostics and Malfunctions",
    ChangesInDriverCycle: "Change in Driver's Cycle, Change in Operating Zone, Off-Duty Time Deferral",
    CommentsAnnotations: "Comments/Annotations",
    AdditionalHoursNotRecorded: "Additional Hours Not Recorded",
    EnginePowerUpAndShutDown: "Engine Power Up and Shut Down",
    TheComplianceReportMayBeMissingSomeInformation: "The compliance report may be missing some information (odometer, engine hours, locations) due to network connection instability.",
    EndingOdometer: "Ending odometer",
    StartingOdometer: "Starting odometer",
    Device: "Device",
    NoOdometerData: "No odometer data to display"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in ReportsTranslationsDictionary) {
        r.push(ReportsTranslationsDictionary[prop]);
    }
    return r;
};

export const ReportsTranslations = getTranslations();